import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export type AttachmentImagePreviewDialogProps = {
  open: boolean;
  onClose: () => void;
  /** 表示する画像 URL（未取得時はダイアログを開かない） */
  src: string | null;
  /** ファイル名（タイトル・代替テキスト） */
  alt: string;
};

/**
 * 添付画像のサムネイルクリック時に、拡大表示するダイアログ
 */
const AttachmentImagePreviewDialog: React.FC<AttachmentImagePreviewDialogProps> = ({
  open,
  onClose,
  src,
  alt,
}) => {
  const show = open && Boolean(src);

  return (
    <Dialog
      open={show}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          m: { xs: 1, sm: 2 },
          maxWidth: 'min(calc(100vw - 16px), 1200px)',
          width: '100%',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: 1.5,
          px: 2,
          pr: 1,
        }}
      >
        <Typography component="span" variant="subtitle2" noWrap sx={{ flex: 1, minWidth: 0 }} title={alt}>
          {alt}
        </Typography>
        <IconButton type="button" aria-label="閉じる" onClick={onClose} size="small" edge="end">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 1, sm: 2 },
          pb: 2,
          pt: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: 'grey.100',
        }}
      >
        {src ? (
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
              maxWidth: '100%',
              maxHeight: 'min(85vh, 900px)',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
              borderRadius: 1,
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentImagePreviewDialog;
